import { forwardRef, useId, useState, type InputHTMLAttributes, type ReactNode } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '../../../shared/ui';
import { inputClass } from './authFieldStyles';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
  error?: string;
  labelExtra?: ReactNode;
};

export const AuthPasswordField = forwardRef<HTMLInputElement, Props>(function AuthPasswordField(
  { label, error, labelExtra, id, className = '', ...rest },
  ref,
) {
  const [show, setShow] = useState(false);
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <div>
      <div className="flex items-center justify-end">
        <label htmlFor={inputId} className="sr-only">{label}</label>
        {labelExtra}
      </div>
      <div className="relative">
        <input
          ref={ref}
          id={inputId}
          type={show ? 'text' : 'password'}
          className={`${inputClass} pr-14 ${className}`}
          {...rest}
          placeholder={label}
        />
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={() => setShow((v) => !v)}
          className="absolute right-5 top-1/2 -translate-y-1/2 !h-auto !w-auto !p-0 !text-white/55 hover:!text-white/80 hover:!bg-transparent"
          aria-label={show ? 'Hide password' : 'Show password'}
        >
          {show ? <EyeOff size={15} /> : <Eye size={15} />}
        </Button>
      </div>
      {error && <p className="text-red-400 text-xs mt-1.5">{error}</p>}
    </div>
  );
});
